import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import StatusList from '../components/StatusList'

export default function ManageStatus() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <div className='eczmembers'>
      <div className="memberTitleContainer">
        <h1 className="newMemberTitle">Membership Status</h1>
        <Link to="/new-status"><button className="memberAddButton">Add New</button></Link>
      </div>
        <StatusList />
    </div>
  )
}
